import React, { useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Lines, FadeUp } from "../components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setSending(true);
        try {
            await axios.post(`${API}/newsletter`, { email: email.trim() });
            toast.success("Welcome to the club");
            setEmail("");
        } catch {
            toast.error("Something went wrong — try again");
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="newsletter" data-testid="newsletter-section" className="border-t border-[rgba(10,10,10,0.12)] bg-[#F2F0EA] px-5 py-28 sm:px-8 lg:px-16 lg:py-40">
            <div className="mx-auto max-w-3xl text-center">
                <Lines
                    lines={["Join The Club."]}
                    className="font-display text-5xl font-black uppercase tracking-tighter text-[#0A0A0A] sm:text-7xl"
                />
                <FadeUp delay={0.2}>
                    <p className="mt-8 text-[10px] uppercase leading-loose tracking-[0.3em] text-[#8E8D8A]">
                        Early access <span className="mx-2 text-[#333]">/</span> Private releases <span className="mx-2 text-[#333]">/</span> Members-only drops
                    </p>
                </FadeUp>
                <FadeUp delay={0.3}>
                    <form data-testid="newsletter-form" onSubmit={submit} className="mx-auto mt-12 flex max-w-md items-end gap-4">
                        <input
                            data-testid="newsletter-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="EMAIL ADDRESS"
                            className="voc-input flex-1 uppercase"
                        />
                        <button
                            data-testid="newsletter-subscribe-button"
                            type="submit"
                            disabled={sending}
                            className="group flex items-center gap-2 whitespace-nowrap pb-3 font-display text-[11px] font-bold uppercase tracking-[0.3em] text-[#0A0A0A]"
                        >
                            Subscribe
                            <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
                        </button>
                    </form>
                </FadeUp>
            </div>
        </section>
    );
}
